import { useEffect, useState } from "react";
import ActionPage from "./action-page";
import ListPage from "./list-page";
import fb from "../../../assets/images/svg/ic_fb_12x12.svg";
import { setPage } from "../../../store/action/pageAction";
import { connect } from "react-redux";
import { Popover } from "react-tiny-popover";
import ImagePageFb from "../components/Images/ImagePageFb";
const _ = require('lodash');

const Page = (props) => {
   const { page } = props;
   const [isShowListPage, setIsShowListPage] = useState(false);
   const [isShow, setIsShow] = useState(false);

   const handleSetShowListPage = () => {
      setIsShowListPage(!isShowListPage);
   }



   return (
      <Popover
         isOpen={isShowListPage}
         align={'center'}
         positions={['top', 'bottom', 'left', 'right']}
         onClickOutside={() => setIsShowListPage(false)}
         clickOutsideCapture={true}
         content={
            <div className={`app-popover  app-popover-hidden-arrow app-popover-placement-rightBottom`} style={{ left: 30 }}>
               <div className="app-popover-content">
                  <div className="app-popover-inner" role="tooltip">
                     <div>
                        <div className="app-popover-inner-content">
                           <div className="app-messaging-first--menu-item--account-list">
                              <div className="app-messaging-first--menu-item app-messaging-first--account--pages">
                                 <div className="app-messaging-first--list-page--container">
                                    <div className="app-messaging-first--page-selected">
                                       <div className="app-messaging-first--page-item page-selected">
                                          <div className="app-messaging-first--page-item--image">
                                             <span content={page.name} className="app-avatar app-messaging-first--page-item--icon app-avatar-lg app-avatar-circle app-avatar-image">
                                                <ImagePageFb src={page.page_avatar} />
                                             </span>
                                             <div className="app-messaging-first--channelIcon">
                                                <div className="app-messaging-first--iconWrapper">
                                                   <img className="app-messaging-first--iconChannel" src={fb} alt="Facebook" />
                                                </div>
                                             </div>
                                          </div>
                                          <div className="app-messaging-first--page-item--info">
                                             <div className="app-messaging-first--page-item--info--name ">
                                                <div className="app-messaging-first--content-1-line" title={page.name}>
                                                   {page.name}
                                                </div>
                                             </div>
                                             <div className="app-messaging-first--page-id">
                                                ID: {page.social_id}
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                    <ListPage />
                                    <ActionPage />
                                    <div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         }
      >
         <Popover
            isOpen={isShow}
            align={'center'}
            positions={['right', 'bottom']}
            clickOutsideCapture={true}
            content={<div className="app-tooltip app-messaging-first-tooltip app-tooltip-placement-right" style={{ marginTop: -15 }}>
               <div className="app-tooltip-content">
                  <div className="app-tooltip-arrow"></div>
                  <div className="app-tooltip-inner" role="tooltip">{page.name}</div>
               </div>
            </div>}
         >
            <div className="app-messaging-first--menu-item--menu-pages"
               onClick={handleSetShowListPage}
               onMouseLeave={() => setIsShow(false)}
               onMouseEnter={() => setIsShow(true)}
            >
               <div className="app-messaging-first--page_selected">
                  <span content={page.name} className="app-avatar app-avatar-circle app-avatar-image">
                     <ImagePageFb src={page.page_avatar} alt={page.name} />
                  </span>
                  <div className="app-messaging-first--channelIcon app-messaging-first--pageChannelSelected">
                     <div className="app-messaging-first--iconWrapper">
                        <img className="app-messaging-first--iconChannel" src={fb} alt="Facebook" />
                     </div>
                  </div>
               </div>

            </div>
         </Popover>
      </Popover>
   )
}

const mapStateToProps = (state) => {
   const { page, pages } = state;

   return {
      page,
      pages
   };
};

export default connect(mapStateToProps, {
   setPage
})(Page);